export default {
  nav_home: '首页',
  nav_categories: '赛事分类',
  nav_about: '关于我们',
  nav_login: '登录',
  nav_register: '注册',
}